import Card from "../../../Card/Card";
import { Button, ButtonOption, ButtonSize } from '../../../Fundamentals/Button';
import SkynetIcon from '../../../Fundamentals/SkynetIcon';
import { dateUtils } from '../../../../Utils';
import { useTranslation } from "react-i18next";

export function VossDiscountOptionsCard({
    dryRunResult,
    selections,
    onOpenDiscountModal,
    onUpdateSelection
}) {
    const { t } = useTranslation();

    const onRemoveDiscount = (discountAgreementId) => {
        onUpdateSelection('discountAgreements',
            selections.discountAgreements.filter(d => d.discountAgreementId !== discountAgreementId)
        );
    };

    const selectedDiscounts = dryRunResult?.discounts ?? [];

    return (
        <Card>
            <Card.Header>
                <Card.Header.Title>{t('vossDiscountOptionsCard.discountAgreements')}</Card.Header.Title>
                <Card.Header.Buttons>
                    <Button
                        option={ButtonOption.PRIMARY}
                        size={ButtonSize.SMALL}
                        onClick={onOpenDiscountModal}
                    >
                        {t('vossDiscountOptionsCard.addDiscount')}
                    </Button>
                </Card.Header.Buttons>
            </Card.Header>
            <Card.Content>
                <table className="table table-stripe skynet-table-no-divider mb-0">
                    <thead>
                        <tr>
                            <th>{t('common.name')}</th>
                            <th>{t('common.startdate')}</th>
                            <th>{t('common.enddate')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {selectedDiscounts.length === 0 ? (
                            <tr>
                                <td colSpan={4}><i>{t('vossDiscountOptionsCard.noDiscountAgreements')}</i></td>
                            </tr>
                        ) : selectedDiscounts.map((discountAgreement, index) => (
                            <tr key={index}>
                                <td>{discountAgreement.name}</td>
                                <td>{dateUtils.formatDate(discountAgreement.startDate)}</td>
                                <td>{dateUtils.formatDate(discountAgreement.endDate)}</td>
                                <td>
                                    <div className="float-right">
                                        <SkynetIcon
                                            icon={"vismaicon vismaicon-cancel-circle"}
                                            onClick={() => onRemoveDiscount(discountAgreement.discountAgreementId)}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Card.Content>
        </Card>
    );
}